// extracted by mini-css-extract-plugin
export default {"radioGroupFieldset":"CheckboxGroup_radioGroupFieldset__hBSz7","horizontal":"CheckboxGroup_horizontal__IlGSv","labelText":"CheckboxGroup_labelText__Z8uDn"};